import { PaymentMethodWithCashlessAndBonus } from "#resources/api/enterprise-generated";

export const PAYMENT_METHOD_WITH_CASHLESS_AND_BONUS_LABEL_PT_BR: Record<
	PaymentMethodWithCashlessAndBonus,
	string
> = {
	ZigPosCredit: "ZigPos Crédito",
	ZigPosCreditInInstallments: "ZigPos Crédito em Parcelas",
	ZigPosDebit: "ZigPos Débito",
	CreditCard: "Cartão de crédito",
	DebitCard: "Cartão de débito",
	Cash: "Dinheiro",
	App: "App",
	Voucher: "Voucher",
	Anticipated: "Antecipado",
	Pix: "Pix",
	Cashless: "Cashless",
	IntegratedFoodVoucher: "Vale-refeição integrado",
	MBWay: "Mbway",
	Bonus: "Bônus",
	MinimumConsumption: "Consumação antecipada",
	Ifood: "Ifood",
};

export type PaymentMethodWithCashlessAndBonusLabelTranslationKeys = typeof PAYMENT_METHOD_WITH_CASHLESS_AND_BONUS_LABEL_PT_BR;
